/** funciones para el modulo de solicitudes masivas en proceso */
import axiosMailUpdate from '../services/axiosApi'
var geocoderAddress = {
    async getGeoCodeAddress(address) {
        let latlng = undefined
        const url =
            'https://nominatim.openstreetmap.org/search.php?q=' +
            encodeURI(address) +
            '&format=jsonv2&countrycodes=' + process.env.VUE_APP_COUNTRY_GEO_CODER + '&limit=1';
        const response = await axiosMailUpdate.get(url)
        if (response.data.length > 0) {
            latlng = { lat: response.data[0].lat, lng: response.data[0].lon }
        }
        return latlng
    },
}
export default geocoderAddress